export default __webpack_public_path__ + "static/stripe-invoice-example-e763703f98a9e4f491853304d2625aa3.png";